export const Routes = {
  HOMEPAGE: '/',
  ABOUT: '/about',
  BLOG: 'https://hashnode.com/@alejandro',
  WORK_HISTORY: '/work-history',
  SANDBOX: '/sandbox',
  SANDBOX_HOOKS: '/sandbox-hooks',
  SIGNUPFORM: '/sign-up-form'
}
